import React from "react";
import { Button, Card } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

const SecretSantaPairs = (  ) => {
   const navigate = useNavigate()
    const data = JSON.parse( sessionStorage.getItem( "secret" ) )
    return (
        <div>
            <h1 className="my-5">
                <u>Secret Santa</u>
            </h1>
            <div>
                <h3>Participant:{`${data.participants}`}</h3>
            </div>
            <div>
                <h4>Budget:{`${data.budget} BAM per participant`}</h4>
            </div>
            <div>
                <div className="card-columns">
                {data.pairs.map( ( pair, index ) => (
                        <div className="col-8 mb-2" key={index}>
                        <Card key={index} text="dark"  style={{ width: 300 }}>
                            {pair[Object.keys( pair )[0]].map( ( name, index ) => (
                                <p key={index}>{name}</p>
                            ) )}
                        </Card>
                        </div>
                    ) )}
                    <br />
                    <Button variant="success" onClick={() => navigate("/secret-santa")}>Go Back</Button>
                </div>
            </div>
        </div>
    );
}
export default SecretSantaPairs;
